export default "__VITE_ASSET__BAhDOhF7__"